// extracted by mini-css-extract-plugin
module.exports =  {"button":"J0Elnf72TTIjNUv7gDK1","label":"OBXTU1YbabpTz6YgAbXH","prefix":"yB5V4YdzAfbS7SXYUASO"};